module.exports = __webpack_public_path__ + "static/media/allen.55d8350c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/june-5/races/images/allen.png
// module id = 639
// module chunks = 40 46 56 57